import { Card, Form, Input, Row, Col } from 'antd'
import React from 'react'

const Layout1 = ({ onChange, initialData }) => { // Removed unused 'index' prop
  const [form] = Form.useForm()
  return (
    <Card
      style={{
        background: '#f0f5ff',
        border: '2px dashed #1890ff',
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialData}
        onValuesChange={(_, allValues) =>
          onChange(allValues) // Pass values directly (no index needed)
        }
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Banner Image URL"
              name="imageUrl"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Banner Title"
              name="title"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Breadcrumb Path"
          name="breadcrumb"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Card>
  )
}
export default Layout1